import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "gfu-product-comparison-table",
  tabindex: "-1",
  "data-qa": "compare-rewards-table"
}
const _hoisted_2 = { class: "gfu-product-comparison-table__header" }
const _hoisted_3 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_comparison_table_column_header = _resolveComponent("product-comparison-table-column-header")
  const _component_sticky_table = _resolveComponent("sticky-table")
  const _component_product_comparison_table_row_header = _resolveComponent("product-comparison-table-row-header")
  const _component_product_comparison_table_value = _resolveComponent("product-comparison-table-value")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sticky_table, { "columns-count": $options.columnsCount }, {
        head: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("th", { class: "gfu-product-comparison-table-separator" }, null, -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedColumnsData, (item) => {
            return (_openBlock(), _createBlock(_component_product_comparison_table_column_header, _mergeProps({
              key: item.productID
            }, { ref_for: true }, item, {
              "data-qa": item.dataQa
            }), null, 16 /* FULL_PROPS */, ["data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["columns-count"])
    ]),
    _createVNode(_component_sticky_table, {
      "columns-count": $options.columnsCount,
      class: _normalizeClass([{ 'gfu-skeleton-sticky-table': $options.isSkeletonVisible }])
    }, {
      body: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedRowsData, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.productID,
            class: "_contents",
            "data-qa": `included-item-row-id:${item.productID}`
          }, [
            _createVNode(_component_product_comparison_table_row_header, _mergeProps({ ref_for: true }, item), null, 16 /* FULL_PROPS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (value, index) => {
              return (_openBlock(), _createBlock(_component_product_comparison_table_value, _mergeProps({
                key: `product:${index}-${value}`
              }, { ref_for: true }, value, {
                "data-qa": `item-included-in:${index}`
              }), null, 16 /* FULL_PROPS */, ["data-qa"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["columns-count", "class"])
  ]))
}